import React from 'react';
import {Row, Col} from 'antd';

import styles from './information.module.scss';
import img1 from './img1.jpg';
import img2 from './img2.jpg';
import {AppSettings} from 'app/actions/actionTypes';

const EventInfo: React.FC<{appSettings: AppSettings | null}> = ({appSettings}) => {
    return (
        <Row className={styles.block}>
            <Col lg={12}>
                <div className={styles.information_card}>
                    <h2>Мрії, які здійснилися</h2>
                    <p>
                        У {appSettings?.previousYear} році нам вдалося здійснити {appSettings?.previousYearGiftsCount}{' '}
                        дитячих мрій.
                    </p>
                    <p>
                        Дякуємо кожному, хто долучився до акції та подарував дитині те, про що вона мріяла: іграшку,
                        книжку, фарби чи омріяний подарунок.
                    </p>
                    <img className={styles.img1} src={img1} alt="img1" />
                </div>
            </Col>
            <Col lg={12} style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
                <img className={styles.img2} src={img2} alt="img2" />
            </Col>
        </Row>
    );
};

export default EventInfo;
